import { ColorPalette } from "@/models/theme/interfaces/theme";
import { lightenColor, darkenColor } from "../../../utils/colors";

/**
 * This function adds specific alpha to a hex color. Adding the last 2 characters in Hex
 *
 * @param {string} color
 * @param {number} alpha
 * @return {*}  {string}
 */
export function addAlphaToColor(color: string, alpha: number): string {
  let hexAlphaValue = Math.round(alpha * 255).toString(16);
  if (hexAlphaValue.length === 1) hexAlphaValue = "0" + hexAlphaValue;
  return color + hexAlphaValue;
}

/**
 * This version of the function is temporary
 * The backend is not ready yet. Probably a new endpoint will serve this data with a new schema.
 * In the meantime, the only color setted is the old highlightColor used as accent color.
 *
 * @export
 * @param {ColorPalette} venueTheme
 */
export function applyCssTheme(venueTheme: ColorPalette) {
  const rootStyle = document.documentElement.style;

  rootStyle.setProperty("--group-2-color-3", venueTheme.accentColor);
  rootStyle.setProperty("--group-3-color-4", venueTheme.accentColor);
  rootStyle.setProperty("--group-3-color-4-alpha-04", addAlphaToColor(venueTheme.accentColor, 0.04));
  rootStyle.setProperty("--group-3-color-4-light", lightenColor(venueTheme.accentColor, 85));
  rootStyle.setProperty("--group-3-color-4-dark", darkenColor(venueTheme.accentColor, 85));
}
